<template>
  <v-carousel cycle interval="4000" :height="isMobile ? '200' : '270'" touch hide-delimiter-background hide-delimiters :show-arrows="false">
    <v-carousel-item v-for="n in 4" :key="n" :src="`slide/${n}.webp`" />
  </v-carousel>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'SlideShowTop',
    computed: {
      isMobile() {
        return this.$vuetify.display.mobile;
      }
    }
  });
</script>

<style scoped>

</style>
